import forEach from 'lodash/forEach';
import routeUtils from 'app/shared/utils/routeUtils';
import type { ListingDetails } from 'app/types/listingDetails.type';

interface ListingInCurrentAreaParams {
  resourceId: string;
  currentListing?: ListingDetails;
}

export function listingInCurrentArea({ resourceId, currentListing }: ListingInCurrentAreaParams): boolean | undefined {
  if (!currentListing) {
    return;
  }

  let foundArea = false;
  const listingAreas = currentListing.areas.breadcrumbs;

  forEach(listingAreas, (area) => {
    if (area.resourceId === resourceId) {
      foundArea = true;
    }
  });

  return foundArea;
}

interface ShouldShowPreviewParams {
  currentListing?: ListingDetails;
  pathname: string;
  hideMobileRightSidebar: boolean;
  previewListing?: ListingDetails;
}

export function shouldShowPreview({
  currentListing,
  pathname,
  hideMobileRightSidebar,
  previewListing,
}: ShouldShowPreviewParams): boolean | null {
  const isPadOrBuildingUrl = routeUtils.isPadOrBuildingUrl(pathname);

  if (!isPadOrBuildingUrl && previewListing && !currentListing && hideMobileRightSidebar) {
    return true;
  }

  return null;
}
